import { ICanvasBannerPlaceholder } from "./CanvasBannerPlaceholder";
import { IFormat } from "./Format";
import { IFormatVersion } from "./FormatVersion";

export interface ICanvasBannerPlaceholderFormat {
    canvasBannerPlaceholderId: string;
    formatId: string;
    canvasBannerPlaceholder: ICanvasBannerPlaceholder;
    format: IFormat;
}

export class CanvasBannerPlaceholderFormat implements ICanvasBannerPlaceholderFormat {
    canvasBannerPlaceholderId: string;
    formatId: string;
    canvasBannerPlaceholder: ICanvasBannerPlaceholder;
    format: IFormat;


    constructor();
    constructor(obj: ICanvasBannerPlaceholderFormat);
    constructor(obj?: ICanvasBannerPlaceholderFormat)
    {
        this.canvasBannerPlaceholderId = obj?.canvasBannerPlaceholderId || undefined;
        this.formatId = obj?.formatId || undefined;
        this.canvasBannerPlaceholder = obj?.canvasBannerPlaceholder || undefined;
        this.format = obj?.format || undefined;
	}
}